/*
  YuleSens — comportements de la marque. Chargé dans layout/theme.liquid (defer), à côté de ys-yulesens.css.

  1. Menu mobile en accordéon : un clic sur un sous-menu l'ouvre sur place (au lieu du panneau qui glisse d'Elixira).
  On intercepte le clic avant le thème (phase de capture), puis on laisse le navigateur ouvrir ou fermer le <details>.
*/
(() => {
  const SOMMAIRE = 'header-drawer .menu-drawer__navigation summary';

  document.addEventListener(
    'click',
    (event) => {
      const sommaire = event.target.closest(SOMMAIRE);
      if (!sommaire) return;

      // Empêche le comportement « panneau » du thème ; l'ouverture native du <details> se fait quand même.
      event.stopPropagation();

      const details = sommaire.parentElement;
      const ouverture = !details.hasAttribute('open');

      // Un seul sous-menu ouvert à la fois au même niveau : plus simple à suivre.
      if (ouverture) {
        const liste = details.closest('ul');
        liste?.querySelectorAll(':scope > li > details[open]').forEach((autre) => {
          if (autre === details) return;
          autre.removeAttribute('open');
          autre.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
        });
      }

      sommaire.setAttribute('aria-expanded', ouverture ? 'true' : 'false');
    },
    true
  );
})();

/*
  2. En-tête des écrans moyens : à partir de 990 px, Elixira affiche le menu en ligne. Quand il ne tient plus sur une
  seule ligne (écran trop étroit ou menu trop long), on passe l'en-tête en mode « tiroir » (.ys-entete-tiroir, voir
  ys-yulesens.css), comme sur mobile. On mesure à chaque changement de largeur et quand les polices sont chargées.
*/
(() => {
  const section = document.querySelector('.section-header');
  const nav = section?.querySelector('.header__inline-menu');
  const liste = nav?.querySelector('.list-menu--inline');
  if (!section || !liste) return;

  const grandEcran = window.matchMedia('(min-width: 990px)');

  const regler = () => {
    section.classList.remove('ys-entete-tiroir');
    if (!grandEcran.matches) return;
    const liens = liste.children;
    if (!liens.length) return;
    // Le menu passe à la ligne si le dernier lien n'est plus sur la même ligne que le premier.
    const passeALaLigne = liens[liens.length - 1].offsetTop > liens[0].offsetTop;
    section.classList.toggle('ys-entete-tiroir', passeALaLigne);
  };

  let attente;
  const reglerBientot = () => {
    cancelAnimationFrame(attente);
    attente = requestAnimationFrame(regler);
  };

  regler();
  window.addEventListener('resize', reglerBientot);
  document.fonts?.ready.then(reglerBientot);
})();

/*
  3. Cartes produit des collections : le choix du format (130 g / 220 g…) met à jour le prix affiché et la variante
  ajoutée au panier.
*/
document.addEventListener('click', (event) => {
  const bouton = event.target.closest('.ys-carte__format');
  if (!bouton || bouton.disabled) return;
  const carte = bouton.closest('.ys-carte');
  carte.querySelectorAll('.ys-carte__format').forEach((b) => b.setAttribute('aria-pressed', b === bouton ? 'true' : 'false'));
  const champ = carte.querySelector('[data-ys-carte-variante]');
  if (champ) champ.value = bouton.dataset.variantId;
  const prix = carte.querySelector('[data-ys-carte-prix]');
  if (prix) prix.textContent = bouton.dataset.prix;
  const barre = carte.querySelector('[data-ys-carte-prix-barre]');   // fins de collection : ancien prix barré
  if (barre) {
    barre.hidden = !bouton.dataset.prixBarre;
    barre.querySelector('[data-ys-carte-barre]').textContent = bouton.dataset.prixBarre;
  }
});

/*
  4. Panier (tiroir et page panier, maquettes v35) : quantités, « Retirer », « Complétez le geste », emballage cadeau et
  petit mot, message « … a été ajouté à votre panier » en haut du tiroir. Le tiroir, la page et l'icône du panier sont
  rafraîchis ensemble (API Section Rendering de Shopify). Le tiroir reste l'élément <cart-drawer> d'Elixira.
*/
(() => {
  let occupe = false;

  const sectionsARendre = () => {
    const ids = ['cart-icon-bubble'];
    if (document.getElementById('CartDrawer')) ids.push('cart-drawer');
    const page = document.querySelector('[data-ys-panier-section]');
    if (page) ids.push(page.dataset.ysPanierSection);
    return ids;
  };

  const lire = (html, selecteur) => new DOMParser().parseFromString(html, 'text/html').querySelector(selecteur);

  const annoncer = (message) => {
    let zone = document.getElementById('ys-panier-annonce');
    if (!zone) {
      zone = document.createElement('p');
      zone.id = 'ys-panier-annonce';
      zone.className = 'visually-hidden';
      zone.setAttribute('aria-live', 'polite');
      document.body.append(zone);
    }
    zone.textContent = '';
    setTimeout(() => {
      zone.textContent = message;
    }, 100);
  };

  // Remplace le tiroir, la page panier et l'icône par leur nouvelle version
  const rendre = (sections) => {
    if (!sections) return;
    const tiroir = document.querySelector('cart-drawer');
    const actuel = document.getElementById('CartDrawer');
    if (sections['cart-drawer'] && tiroir && actuel) {
      const neuf = lire(sections['cart-drawer'], '#CartDrawer');
      if (neuf) {
        actuel.innerHTML = neuf.innerHTML;
        actuel.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => tiroir.close());
        tiroir.classList.toggle('is-empty', !!actuel.querySelector('.drawer__inner-empty'));
      }
    }
    if (sections['cart-icon-bubble']) {
      const neuf = lire(sections['cart-icon-bubble'], '.shopify-section');
      if (neuf) document.querySelectorAll('#cart-icon-bubble').forEach((icone) => (icone.innerHTML = neuf.innerHTML));
    }
    const page = document.querySelector('[data-ys-panier-section]');
    if (page && sections[page.dataset.ysPanierSection]) {
      const neuf = lire(sections[page.dataset.ysPanierSection], '[data-ys-panier-section]');
      if (neuf) page.replaceWith(neuf);
    }
  };

  // Après un rafraîchissement, remet le focus sur le même bouton (ou sur le titre si la ligne a disparu)
  const replacerFocus = (repere) => {
    if (!repere) return;
    const racine = repere.tiroir
      ? document.querySelector('#CartDrawer [data-ys-panier]')
      : document.querySelector('[data-ys-panier-section]');
    if (!racine) return;
    const cible = (repere.selecteur && racine.querySelector(repere.selecteur)) || racine.querySelector('h1, h2');
    if (!cible) return;
    if (!cible.matches('button, a, textarea') && !cible.hasAttribute('tabindex')) cible.setAttribute('tabindex', '-1');
    cible.focus();
  };

  const afficherErreur = (racine, message) => {
    const zone = racine?.querySelector('[data-ys-erreur]');
    if (!zone) return;
    zone.textContent = message || "Le panier n'a pas pu être mis à jour. Merci de réessayer.";
    zone.hidden = false;
  };

  const envoyer = async (racine, adresse, corps, repere) => {
    if (occupe) return null;
    occupe = true;
    racine?.setAttribute('aria-busy', 'true');
    try {
      const reponse = await fetch(`${adresse}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...corps, sections: sectionsARendre(), sections_url: window.location.pathname }),
      });
      const etat = await reponse.json();
      if (!reponse.ok || etat.status) {
        afficherErreur(racine, etat.description || etat.message);
        return null;
      }
      rendre(etat.sections);
      replacerFocus(repere);
      const total = document.querySelector(
        repere?.tiroir ? '#CartDrawer .ys-total__montant' : '[data-ys-panier-section] .ys-total__montant'
      );
      annoncer(total ? `Panier mis à jour. Sous-total : ${total.textContent.trim()}` : 'Panier mis à jour.');
      return etat;
    } catch (erreur) {
      afficherErreur(racine);
      return null;
    } finally {
      occupe = false;
      racine?.removeAttribute('aria-busy');
    }
  };

  // Message vert du tiroir : « Ambre & Lumière · 220 g a été ajouté à votre panier »
  const montrerAjout = (idVariante, nombre) => {
    const tiroir = document.getElementById('CartDrawer');
    const boite = tiroir?.querySelector('[data-ys-statut]');
    if (!boite) return;
    const texte = boite.querySelector('[data-ys-statut-texte]');
    texte.textContent = '';
    if (nombre > 1) {
      texte.textContent = (boite.dataset.ysPluriel || '').replace('[n]', nombre);
    } else {
      const ligne = tiroir.querySelector(`.ys-ligne[data-ys-variante="${idVariante}"]`);
      if (!ligne) return;
      const nom = document.createElement('strong');
      nom.textContent = ligne.dataset.ysLibelle;
      texte.append(nom, ` ${boite.dataset.ysSuffixe || ''}`);
    }
    boite.hidden = false;
  };

  // Ajouts faits ailleurs (bouton « Ajouter au panier », accumulation) : le tiroir d'Elixira se rafraîchit, on ajoute le message
  customElements.whenDefined('cart-drawer').then(() => {
    const Tiroir = customElements.get('cart-drawer');
    const rendreOrigine = Tiroir.prototype.renderContents;
    Tiroir.prototype.renderContents = function (etat) {
      rendreOrigine.call(this, etat);
      this.classList.toggle('is-empty', !!this.querySelector('.drawer__inner-empty'));
      if (Array.isArray(etat?.items)) {
        if (etat.items.length > 1) montrerAjout(null, etat.items.length);
        else if (etat.items[0]) montrerAjout(etat.items[0].variant_id, 1);
      } else if (etat?.variant_id) {
        montrerAjout(etat.variant_id, 1);
      }
    };
  });

  document.addEventListener('click', async (event) => {
    const racine = event.target.closest('[data-ys-panier]');
    if (!racine || occupe) return;
    const dansTiroir = !!racine.closest('#CartDrawer');
    const cleEmballage = racine.dataset.ysEmballageCle;

    // Quantité et « Retirer »
    const pas = event.target.closest('[data-ys-pas]');
    const retirer = event.target.closest('[data-ys-retirer]');
    if (pas || retirer) {
      const ligne = event.target.closest('.ys-ligne');
      if (!ligne || (pas && pas.disabled)) return;
      const actuelle = Number(ligne.dataset.ysQuantite);
      const quantite = retirer ? 0 : Math.max(1, actuelle + Number(pas.dataset.ysPas));
      if (quantite === actuelle) return;
      const cle = ligne.dataset.ysCle;
      const updates = { [cle]: quantite };
      const corps = { updates };
      // Le dernier article retiré emporte l'emballage cadeau et le petit mot
      const reste = [...racine.querySelectorAll('.ys-ligne')].reduce(
        (n, l) => n + (l === ligne ? quantite : Number(l.dataset.ysQuantite)),
        0
      );
      if (reste === 0) {
        if (cleEmballage) updates[cleEmballage] = 0;
        corps.attributes = { 'Emballage cadeau': '' };
        corps.note = '';
      }
      const selecteur = quantite > 0 && pas ? `.ys-ligne[data-ys-cle="${cle}"] [data-ys-pas="${pas.dataset.ysPas}"]` : null;
      await envoyer(racine, window.routes.cart_update_url, corps, { tiroir: dansTiroir, selecteur });
      return;
    }

    // « Complétez le geste » : ajoute le produit proposé
    const geste = event.target.closest('[data-ys-geste]');
    if (geste) {
      const id = Number(geste.dataset.ysGeste);
      const etat = await envoyer(racine, window.routes.cart_add_url, { items: [{ id, quantity: 1 }] }, { tiroir: dansTiroir });
      if (etat && dansTiroir) montrerAjout(id, 1);
      return;
    }

    // « C'est pour offrir » : ajoute ou retire le produit « Emballage cadeau » (sans ce produit : attribut de la commande)
    const offrir = event.target.closest('[data-ys-offrir]');
    if (offrir) {
      const actif = offrir.getAttribute('aria-pressed') === 'true';
      const variante = offrir.dataset.ysEmballageVariante;
      const repere = { tiroir: dansTiroir, selecteur: '[data-ys-offrir]' };
      if (actif) {
        const corps = { updates: {}, attributes: { 'Emballage cadeau': '' }, note: '' };
        if (offrir.dataset.ysEmballageCle) corps.updates[offrir.dataset.ysEmballageCle] = 0;
        await envoyer(racine, window.routes.cart_update_url, corps, repere);
      } else if (variante) {
        await envoyer(racine, window.routes.cart_add_url, { items: [{ id: Number(variante), quantity: 1 }] }, repere);
      } else {
        await envoyer(racine, window.routes.cart_update_url, { attributes: { 'Emballage cadeau': 'Oui' } }, repere);
      }
    }
  });

  // Petit mot : enregistré dans la note de la commande pendant la saisie
  let attenteMot;
  document.addEventListener('input', (event) => {
    const mot = event.target.closest('[data-ys-mot]');
    if (!mot) return;
    clearTimeout(attenteMot);
    attenteMot = setTimeout(() => {
      fetch(`${window.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: mot.value }),
      }).catch(() => {});
    }, 500);
  });
})();
